import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import Button from '../Button';
import { isPick7iOSWebView } from '../../utils/authUtils';

const SPORT_CONFIG = {
    racing: {
        cardTitle: 'ITV7 Racing',
        headerBg: '/img/logos/itv7-racing-mobile.jpg'
    },
    football: {
        cardTitle: 'ITV7 Football',
        headerBg: '/img/logos/itv7-football-mobile.jpg'
    }
};

const PlayItv = ({
    titleText,
    buttonText,
    TermsLink,
    ButtonLink,
    sportType
}) => {
    const { cardTitle, headerBg } =
        SPORT_CONFIG[sportType] || SPORT_CONFIG.racing;

    return (
        <Styled.Wrapper>
            <Styled.CardHeader bgImage={headerBg} />
            <Styled.CardBody>
                <Styled.Title>{cardTitle}</Styled.Title>
                <Styled.Body>{titleText}</Styled.Body>
                {!isPick7iOSWebView() && (
                    <Styled.ButtonWrapper>
                        <ButtonLink>
                            <Button
                                type="secondary"
                                buttonText={buttonText}
                                disabled={false}
                            />
                        </ButtonLink>
                    </Styled.ButtonWrapper>
                )}
                <Styled.Terms>
                    Opening times may be subject to change.
                </Styled.Terms>
                <TermsLink>
                    <Styled.TermsLink>
                        18+ and UK only, T&Cs apply, see here.
                    </Styled.TermsLink>
                </TermsLink>
            </Styled.CardBody>
        </Styled.Wrapper>
    );
};

PlayItv.defaultProps = {
    sportType: 'racing'
};

PlayItv.propTypes = {
    titleText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired,
    ButtonLink: PropTypes.func.isRequired,
    sportType: PropTypes.oneOf(['racing', 'football'])
};

export default PlayItv;
